<!--
                               o8o                 .
                               `"'               .o8
   .oooo.o  .ooooo.  oooo d8b oooo  oo.ooooo.  .o888oo
  d88(  "8 d88' `"Y8 `888""8P `888   888' `88b   888
  `"Y88b.  888        888      888   888   888   888
  o.  )88b 888   .o8  888      888   888   888   888 .
  8""888P' `Y8bod8P' d888b    o888o  888bod8P'   "888"
                                     888
                                    o888o
 -->

<script>

import { TweenMax as Tween, TimelineMax as Line, Power1 } from 'gsap'

export default {

  name: 'PlayerWidget',

  props: {
    content: [Object]
  },

  data () {
    return {
      poster: true,
      playing: false,
      tl: null
    }
  },

  methods: {
    play () {
      this.$refs.video.play()
    },

    stop () {
      this.$refs.video.pause()
    },

    onStatusChange () {
      this.playing = !this.$refs.video.paused
      if (this.poster) this.poster = false
    },

    onPlay (event) {
      this.progress = event.target.currentTime
    },

    onEnd () {
      this.$refs.video.currentTime = 0
    },

    beforeAppear () {
      const tl = this.tl = new Line({ paused: true })

      tl.from(this.$refs.media, 1, {
        autoAlpha: 0,
        ease: Power1.easeOut,
        // onUpdate: () => {
        //   const y = this.$refs.media.style.opacity * 100

        //   Tween.set(this.$refs.media, {
        //     clipPath: `polygon(0% 0%, 100% 0%, 100% ${y}%, 0% ${y}%)`
        //   })
        // }
      })

      if (this.$refs.note) {
        tl.from(this.$refs.note, 1, {
          autoAlpha: 0,
          y: -20,
          ease: Power1.easeOut
        }, 0.9)
      }
    },

    appear () {
      this.tl.play()
    }
  }

}

</script>


<!--

  oooo                                                  .
  `888                                                .o8
   888   .oooo.   oooo    ooo  .ooooo.  oooo  oooo  .o888oo
   888  `P  )88b   `88.  .8'  d88' `88b `888  `888    888
   888   .oP"888    `88..8'   888   888  888   888    888
   888  d8(  888     `888'    888   888  888   888    888 .
  o888o `Y888""8o     .8'     `Y8bod8P'  `V88V"V8P'   "888"
                  .o..P'
                  `Y8P'
 -->


<template lang="pug">

.widget
  .widget-main.widget-main__video(ref="media")
    .widget-main__controls.widget-controls
      transition(name="fade")
        .widget-controls__poster(v-if="content.poster && !playing"): img(:src="content.poster.url")
      transition(name="button")
        .widget-controls__play-button.play-button(v-if="!playing", @click="play")
          //- img.play-button__static(src="../../../assets/play-icon.svg" alt="play-icon")
          //- img.play-button__hover(src="../../../assets/play-icon-orange.svg" alt="play-icon")
    video.widget-main__video(
        preload="auto",
        ref="video",
        @click="stop",
        @playing="onStatusChange",
        @pause="onStatusChange",
        @timeupdate="onPlay",
        @ended="onEnd",
        :class="{ 'is-playing': playing }")
      source(
        v-for="video, index in content.media",
        :key="index",
        :src="video.url",
        :type="'video/' + video.type")
  .widget-note(v-if="content.note" ref="note") {{ content.note }}

</template>


<!--
               .               oooo
             .o8               `888
   .oooo.o .o888oo oooo    ooo  888   .ooooo.   .oooo.o
  d88(  "8   888    `88.  .8'   888  d88' `88b d88(  "8
  `"Y88b.    888     `88..8'    888  888ooo888 `"Y88b.
  o.  )88b   888 .    `888'     888  888    .o o.  )88b
  8""888P'   "888"     .8'     o888o `Y8bod8P' 8""888P'
                   .o..P'
                   `Y8P'
 -->


<style lang="stylus" scoped>

.widget
  padding-top 60px
  padding-bottom 60px
  display flex
  flex-direction column
  justify-content center

  +mobile()
    padding-top 35px
    padding-bottom 35px

.widget-main
  position relative
  height 0
  padding-bottom 56.25%
  overflow hidden


  &__video
    width 100%
    height 700px
    overflow hidden
    object-fit contain
    padding-bottom: 0

    &.is-playing
      z-index 1
      cursor pointer
      position: relative

  &__controls
    position absolute
    top 0
    left 0
    width 100%
    height 100%

.widget-controls
  display flex
  justify-content center
  align-items center
  background-repeat no-repeat
  background-size cover

  &__poster
    z-index 1
    position absolute
    top 0
    left 0
    width 100%
    height 100%
    // opacity 0.5

    img[src=""]
      display: none
    img
        width 100%
        height 100%
        object-fit cover


  &__play-button
    z-index 2
    position relative

.play-button
  display flex
  justify-content center
  align-items center
  width 120px
  height 120px
  border-radius 50%
  background-color white
  box-shadow 0 2px 4px rgba(0, 0, 0, .5)
  cursor pointer
  transition transform .5s, box-shadow .5s, background .5s
  background-image url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSI0NnB4IiBoZWlnaHQ9IjUzcHgiIHZpZXdCb3g9IjAgMCA0NiA1MyIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4gICAgICAgIDx0aXRsZT5QYWdlIDE8L3RpdGxlPiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4gICAgPGRlZnM+PC9kZWZzPiAgICA8ZyBpZD0iMTM2NiIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+ICAgICAgICA8ZyBpZD0iQXJ0Y2lsZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTY2OC4wMDAwMDAsIC0yODUzLjAwMDAwMCkiIGZpbGw9IiMwMDUyQTYiPiAgICAgICAgICAgIDxnIGlkPSJHcm91cCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNjIzLjAwMDAwMCwgMjgxOS4wMDAwMDApIj4gICAgICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLTUiPiAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTY4LjAwMDYyMDgsMzcuMzE4MDgzNyBMNTguMzAxNTExNSw1NC4yNjkxNzY4IEw1MS4yNDk0MTk3LDY2LjU5NTQzODYgTDQxLjY4MTkxNjMsODMuMzE4MDgzNyBMOTQuMzE4MDgzNyw4My4zMTgwODM3IEw4NC43NTA1ODAzLDY2LjU5NTQzODYgTDc3LjY5ODQ4ODUsNTQuMjY5MTc2OCBMNjguMDAwNjIwOCwzNy4zMTgwODM3IFogTTY4LjAwMDYyMDgsNTkuODE4OTc0NCBMNzUuMDUxNDcxLDcyLjE0NTIzNjIgTDYwLjk0NzI4NzQsNzIuMTQ1MjM2MiBMNjguMDAwNjIwOCw1OS44MTg5NzQ0IFoiIGlkPSJQYWdlLTEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDY4LjAwMDAwMCwgNjAuMzE4MDg0KSBzY2FsZSgxLCAtMSkgcm90YXRlKC0yNzAuMDAwMDAwKSB0cmFuc2xhdGUoLTY4LjAwMDAwMCwgLTYwLjMxODA4NCkgIj48L3BhdGg+ICAgICAgICAgICAgICAgIDwvZz4gICAgICAgICAgICA8L2c+ICAgICAgICA8L2c+ICAgIDwvZz48L3N2Zz4=")
  background-position center
  background-repeat no-repeat
  background-size 40%
  background-position-x calc(50% + 5px)

  +mobile()
    width 60px
    height 60px

  &__hover
    opacity 0
    visibility hidden

  img
    position absolute
    top 0
    right 0
    bottom 0
    left 0
    margin auto
    transition opacity .1s, visibility .1s
    transform translateX(5px)

    +mobile()
      max-width 50%

  &:hover
    transform scale(1.1)
    box-shadow 0 8px 16px rgba(0, 0, 0, .3)
    transition transform .5s, box-shadow .5s, background .5s
    background-image url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSI0NnB4IiBoZWlnaHQ9IjUzcHgiIHZpZXdCb3g9IjAgMCA0NiA1MyIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4gICAgICAgIDx0aXRsZT5QYWdlIDE8L3RpdGxlPiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4gICAgPGRlZnM+PC9kZWZzPiAgICA8ZyBpZD0iMTM2NiIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+ICAgICAgICA8ZyBpZD0iQXJ0Y2lsZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTY2OC4wMDAwMDAsIC0yODUzLjAwMDAwMCkiIGZpbGw9IiNlZTZiNGMiPiAgICAgICAgICAgIDxnIGlkPSJHcm91cCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNjIzLjAwMDAwMCwgMjgxOS4wMDAwMDApIj4gICAgICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLTUiPiAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTY4LjAwMDYyMDgsMzcuMzE4MDgzNyBMNTguMzAxNTExNSw1NC4yNjkxNzY4IEw1MS4yNDk0MTk3LDY2LjU5NTQzODYgTDQxLjY4MTkxNjMsODMuMzE4MDgzNyBMOTQuMzE4MDgzNyw4My4zMTgwODM3IEw4NC43NTA1ODAzLDY2LjU5NTQzODYgTDc3LjY5ODQ4ODUsNTQuMjY5MTc2OCBMNjguMDAwNjIwOCwzNy4zMTgwODM3IFogTTY4LjAwMDYyMDgsNTkuODE4OTc0NCBMNzUuMDUxNDcxLDcyLjE0NTIzNjIgTDYwLjk0NzI4NzQsNzIuMTQ1MjM2MiBMNjguMDAwNjIwOCw1OS44MTg5NzQ0IFoiIGlkPSJQYWdlLTEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDY4LjAwMDAwMCwgNjAuMzE4MDg0KSBzY2FsZSgxLCAtMSkgcm90YXRlKC0yNzAuMDAwMDAwKSB0cmFuc2xhdGUoLTY4LjAwMDAwMCwgLTYwLjMxODA4NCkgIj48L3BhdGg+ICAgICAgICAgICAgICAgIDwvZz4gICAgICAgICAgICA8L2c+ICAgICAgICA8L2c+ICAgIDwvZz48L3N2Zz4=")

  &:hover &__hover
    opacity 1
    visibility visible

.widget-note
  width 554px
  margin-top 36px
  font-size 12px
  line-height 20px
  color dark

// ===========================================
// Animations
// ===========================================

.button-enter
.button-leave-to
  opacity 0
  visibility hidden
  transform scale(0.9) !important
  box-shadow 0 1px 2px rgba(0, 0, 0, .5) !important

.button-enter-active
.button-leave-active
  transition opacity .5s, visibility .5s, transform .5s, box-shadow .5s
  pointer-events none

.fade-enter
.fade-leave-to
  opacity 0
  visibility hidden

.fade-enter-active
.fade-leave-active
  transition opacity .5s, visibility .5s

</style>



// WEBPACK FOOTER //
// player.vue?ec5932ea